import { render, staticRenderFns } from "./NotifyFirebaseDialog.vue?vue&type=template&id=61b22043&scoped=true"
import script from "./NotifyFirebaseDialog.vue?vue&type=script&lang=js"
export * from "./NotifyFirebaseDialog.vue?vue&type=script&lang=js"
import style0 from "./NotifyFirebaseDialog.vue?vue&type=style&index=0&id=61b22043&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b22043",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b22043')) {
      api.createRecord('61b22043', component.options)
    } else {
      api.reload('61b22043', component.options)
    }
    module.hot.accept("./NotifyFirebaseDialog.vue?vue&type=template&id=61b22043&scoped=true", function () {
      api.rerender('61b22043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/NotifyFirebaseDialog.vue"
export default component.exports